import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import PageTransition from "@/components/PageTransition";
import PortalIntro from "@/components/PortalIntro";

import Home from "@/pages/Home";
import Experiences from "@/pages/Experiences";
import LevelUpXR from "@/pages/LevelUpXR";
import HomeEducation from "@/pages/HomeEducation";
import UbuntuRetreat from "@/pages/UbuntuRetreat";
import Join from "@/pages/Join";
import XRStudio from "@/pages/XRStudio";
import Corporate from "@/pages/Corporate";
import Festivals from "@/pages/Festivals";
import Community from "@/pages/Community";
import WhatsOn from "@/pages/WhatsOn";
import Impact from "@/pages/Impact";
import InteractivePlayground from "@/pages/InteractivePlayground";
import AfterSchoolClubs from "@/pages/AfterSchoolClubs";
import KultureLab from "@/pages/KultureLab";
import EventDetail from "@/pages/EventDetail";
import ShowDetail from "@/pages/ShowDetail";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";
import Policies from "@/pages/Policies";
import Projects from "@/pages/Projects";
import Family from "@/pages/Family";
import Schools from "@/pages/Schools";
import Youth from "@/pages/Youth";
import NotFound from "@/pages/NotFound";
import EditOnSite from "@/components/admin/EditOnSite";

function App() {
  return (
    <div className="App tok-grain min-h-screen bg-[#050505] text-white">
      <PortalIntro />
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="relative">
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/creative-academy" element={<Navigate to="/level-up-xr" replace />} />
              <Route path="/level-up" element={<Navigate to="/level-up-xr" replace />} />
              <Route path="/level-up-xr" element={<LevelUpXR />} />
              <Route path="/home-education" element={<HomeEducation />} />
              <Route path="/ubuntu-retreat" element={<UbuntuRetreat />} />
              <Route path="/ubuntu" element={<Navigate to="/ubuntu-retreat" replace />} />
              <Route path="/mindfulness-retreat" element={<Navigate to="/ubuntu-retreat" replace />} />
              <Route path="/wellness" element={<Navigate to="/ubuntu-retreat" replace />} />
              <Route path="/join" element={<Join />} />
              <Route path="/xr-studio" element={<XRStudio />} />
              <Route path="/corporate" element={<Corporate />} />
              <Route path="/festivals" element={<Festivals />} />
              <Route path="/community" element={<Community />} />
              <Route path="/whats-on" element={<WhatsOn />} />
              <Route path="/whats-on/:eventId" element={<EventDetail />} />
              <Route path="/shows/:slug" element={<ShowDetail />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/family" element={<Family />} />
              <Route path="/schools" element={<Schools />} />
              <Route path="/youth" element={<Youth />} />
              <Route path="/interactive-playground" element={<InteractivePlayground />} />
              <Route path="/after-school-clubs" element={<AfterSchoolClubs />} />
              <Route path="/kulture-lab" element={<KultureLab />} />
              <Route path="/gallery" element={<Navigate to="/" replace />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/policies/:slug" element={<Policies />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </PageTransition>
        </main>
        <Footer />
        <EditOnSite />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,215,0,0.25)",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
